import React from 'react'

import { SpookySkeleton, SkeletonCard } from '@offerzen/pinata-shame'

import styles from './styles'

const MatchingRequirementsSkeleton = () => {
  return (
    <SpookySkeleton>
      <span className={styles.accessiblyHidden}>Loading</span>
      <SkeletonCard className={styles.card} />
    </SpookySkeleton>
  )
}

export default MatchingRequirementsSkeleton
